import {
  CreateFHIRClientDownloadPermission,
  CreateFHIRClientParameterPermission,
  CreateFHIRClientPayload,
  FHIRClient,
  FHIRClientDownloadPermission,
  FHIRClientParameterPermission,
  GetFHIRClientsResponsePayload,
  GetFHIRRequestPayload,
  UpdateFHIRClientPayload
} from '@/views/AdminThirdPartyManagement/types/admin-fhir-access-management.types';
import { axios } from './axios';

export interface UpdateDefaultParameterPayload {
  accessChosen: string;
  defaultCardinality?: number;
  maxCardinality?: number;
}

export interface UpdateListValueAccessPayload {
  id: number;
  accessChosen: string;
}

export interface UpdateDownloadFormatPayload {
  formatTypeId: number;
  isEnabled: boolean;
}

export interface UpdateDownloadSettingsPayload {
  formats: UpdateDownloadFormatPayload[];
  isUnlimited: boolean;
  downloadLimit?: number;
}

export const fhirApi = {
  getDefaultParameters() {
    return axios.get('fhir/default-parameters');
  },

  updateDefaultParameter(id: number, payload: UpdateDefaultParameterPayload) {
    return axios.patch(`fhir/default-parameters/${id}`, payload);
  },

  updateDefaultParameterListValues(
    id: number,
    listValues: UpdateListValueAccessPayload[]
  ) {
    return axios.patch(`fhir/default-parameters/${id}/list-values`, {
      listValues
    });
  },

  updateDownloadSettings(payload: UpdateDownloadSettingsPayload) {
    return axios.patch('fhir/default-download-permissions', payload);
  },

  getDefaultDownloadPermissions() {
    return axios.get('fhir/default-download-permissions');
  },

  getFhirClients(params: GetFHIRRequestPayload) {
    return axios.get<GetFHIRClientsResponsePayload>('fhir/clients', { params });
  },

  getFhirClientById(id: number) {
    return axios.get<FHIRClient>(`fhir/clients/${id}`);
  },

  createFhirClient(payload: CreateFHIRClientPayload) {
    return axios.post<FHIRClient>('fhir/clients', payload);
  },

  updateFhirClient(id: number, payload: UpdateFHIRClientPayload) {
    return axios.patch<FHIRClient>(`fhir/clients/${id}`, payload);
  },

  deleteFhirClient(id: number) {
    return axios.delete<FHIRClient>(`fhir/clients/${id}`);
  },

  updateClientParameters(
    id: number,
    parameters: CreateFHIRClientParameterPermission[]
  ) {
    return axios.patch<FHIRClientParameterPermission[]>(
      `fhir/clients/${id}/parameters`,
      { parameters }
    );
  },

  updateClientDownload(
    id: number,
    payload: CreateFHIRClientDownloadPermission
  ) {
    return axios.patch<FHIRClientDownloadPermission>(
      `fhir/clients/${id}/download`,
      payload
    );
  }
};
